const MS_DIA = 86400000;

export const calcConformidade = (vinculo) => {
  if (!vinculo?.ativo) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);

  const checkTipo = (resultado, validade) => {
    if (!validade) return 'sem_teste';
    const d = new Date(validade);
    if (d < today) return 'vencido';
    const diff = (d - today) / MS_DIA;
    if (diff <= 30) return 'proximo';
    if (resultado === 'REPROVADO') return 'vencido';
    if (resultado === 'REFAZER')   return 'refazer';
    return 'em_dia';
  };

  const resp = checkTipo(vinculo.ultimo_resultado_respiratorio, vinculo.ultima_validade_respiratorio);
  const aud  = checkTipo(vinculo.ultimo_resultado_auditivo,    vinculo.ultima_validade_auditivo);

  if (resp === 'vencido'   || aud === 'vencido')   return 'vencido';
  if (resp === 'refazer'   || aud === 'refazer')   return 'refazer';
  if (resp === 'proximo'   || aud === 'proximo')   return 'proximo';
  if (resp === 'sem_teste' && aud === 'sem_teste') return 'sem_teste';
  return 'em_dia';
};

export const CONFORMIDADE_CONFIG = {
  em_dia:    { label: 'Em dia',         color: '#198754', icon: 'bi-check-circle-fill' },
  proximo:   { label: 'Vence em breve', color: '#ffc107', icon: 'bi-exclamation-triangle-fill' },
  vencido:   { label: 'Vencido',        color: '#dc3545', icon: 'bi-x-circle-fill' },
  refazer:   { label: 'Refazer teste',  color: '#fd7e14', icon: 'bi-arrow-repeat' },
  sem_teste: { label: 'Sem teste',      color: '#6c757d', icon: 'bi-dash-circle' },
};

export const BadgeConformidade = ({ vinculo }) => {
  const status = calcConformidade(vinculo);
  if (!status) return null;
  const cfg = CONFORMIDADE_CONFIG[status];
  return (
    <span title={cfg.label}>
      <i className={`bi ${cfg.icon}`} style={{ color: cfg.color }}></i>
      <span className="small ms-1" style={{ color: cfg.color }}>{cfg.label}</span>
    </span>
  );
};
